// 运行时配置（来自 public/runtime-config.js，不参与打包混淆，可线上直接改）
const RUNTIME_CONFIG =
  (typeof window !== 'undefined' && window.__APP_RUNTIME_CONFIG__) || {}

// 启动时打印当前加载的运行时配置版本，便于线上排查
if (typeof window !== 'undefined') {
  const v = RUNTIME_CONFIG.CONFIG_VERSION || '(missing - using build-time defaults)'
  // eslint-disable-next-line no-console
  console.info('[runtime-config] version:', v)
}

// 应用配置
export const APP_CONFIG = {
  // 后端 API 地址
  BASE_API: 'https://datas.8090pay.com',

  // 应用信息
  APP_ID: 14,
  APP_KEY: 'FScIguDHUEoPz7Q-yjU58w==',

  // 支付配置
  DEFAULT_PAYMENT_METHOD: 'epay_alipay',

  // 其他配置
  TIMEOUT: 15000,

  // 当前运行时配置版本号（线上修改 runtime-config.js 后会变化，便于排查）
  CONFIG_VERSION: RUNTIME_CONFIG.CONFIG_VERSION || 'unknown',

  // 购买服务开关
  // 真正生效的值来自 public/runtime-config.js（部署后可直接在线编辑 dist/runtime-config.js）。
  // 下面这行只是回退默认值——当 runtime-config.js 缺失或字段未提供时使用。
  ENABLE_PURCHASE:
    RUNTIME_CONFIG.ENABLE_PURCHASE !== undefined
      ? RUNTIME_CONFIG.ENABLE_PURCHASE === true
      : false,

  // 业务类型配置
  // 可选值:
  // 'electronics', 'internet', 'trading', 'service', 'internet_dev', 'corporate_website'
  BUSINESS_TYPE: 'corporate_website',

  // 页面显示配置
  PAGE_TITLE: '宁德市天晓传媒',

  // 备案信息
  ICP_NUMBER: '闽ICP备2026006013号',
  ICP_LINK: 'https://beian.miit.gov.cn/',

  // 公司资料配置
  COMPANY_PROFILE: {
    fullName: '宁德市天晓传媒有限公司',
    shortName: '天晓传媒',
    establishedYear: '2022-09-14',
    location: '福建省宁德市福安市',
    industry: '互联网技术开发 · 数字文化服务',
    registeredCapital: '100万人民币',
    licenses: '许可资质4项',
    heroTitle: '扎根闽东的互联网技术开发与数字文化服务商',
    heroSubtitle: '围绕软件开发、网络技术服务与数字文化创意内容，为客户提供从技术研发到数字内容落地的一体化服务。',
    companyIntro:
      '宁德市天晓传媒有限公司成立于2022年9月，坐落于福建省宁德市福安市，是一家专注互联网技术开发与数字文化服务的企业。公司业务涵盖网络技术服务、软件开发、网络与信息安全软件开发、系统集成，以及数字文化创意内容应用、信息网络传播视听节目、网络文化经营等，同时提供信息技术咨询、数据处理和存储支持等服务，致力于以扎实的技术能力驱动数字文化内容的创作与传播。',
    aboutTitle: '公司介绍',
    companyVision: '以扎实的技术研发能力与优质的数字文化内容，成为客户可信赖的互联网技术与数字文化合作伙伴。',
    aboutPoints: [
      '成立于2022年9月，坐落于福建省宁德市福安市',
      '专注互联网技术开发与数字文化创意服务',
      '具备互联网信息服务、信息网络传播视听节目等许可资质',
      '兼具软件开发、网络技术与数字内容运营能力',
    ],
    serviceTitle: '业务方向',
    serviceItems: [
      {
        name: '互联网技术开发',
        desc: '提供网络技术服务、软件开发、网络与信息安全软件开发及系统集成，支撑业务的数字化研发与落地。',
      },
      {
        name: '数字文化创意服务',
        desc: '围绕数字文化创意内容应用、信息网络传播视听节目与网络文化经营，开展数字内容的创作与传播。',
      },
      {
        name: '信息技术与数据服务',
        desc: '提供信息技术咨询、数据处理和存储支持以及互联网信息服务，助力客户的数据与信息化建设。',
      },
    ],
    highlightItems: [
      {
        title: '技术研发能力扎实',
        desc: '覆盖软件开发、网络技术服务与信息安全软件开发，具备完整的技术落地能力。',
      },
      {
        title: '数字文化内容运营',
        desc: '围绕数字文化创意内容、视听节目与网络文化经营，形成内容创作与传播的闭环。',
      },
      {
        title: '资质相对齐全',
        desc: '涵盖互联网信息服务、信息网络传播视听节目、网络文化经营等许可项目。',
      },
    ],
    operationItems: [
      { label: '企业名称', value: '宁德市天晓传媒有限公司' },
      { label: '成立日期', value: '2022-09-14' },
      { label: '所在地区', value: '福建省宁德市福安市' },
      { label: '所属行业', value: '互联网技术开发 · 数字文化服务' },
      { label: '注册资本', value: '100万人民币' },
      { label: '许可资质', value: '互联网信息服务等4项' },
      { label: '备案号', value: '闽ICP备2026006013号' },
    ],
    cooperationSteps: [
      {
        title: '需求沟通',
        desc: '明确技术开发或数字内容服务的目标、功能与交付要求。',
      },
      {
        title: '研发与制作',
        desc: '结合技术开发与内容创作能力，输出可执行方案并完成研发制作。',
      },
      {
        title: '上线与运营',
        desc: '完成产品或内容上线，并持续跟进运行效果与后续迭代优化。',
      },
    ],
    contactTitle: '联系信息',
    contactSubtitle: '欢迎通过邮箱与我们联系，洽谈互联网技术开发与数字文化服务合作。',
    contactPhone: '',
    contactEmail: '999330119@qq.com',
    contactAddress: '福建省宁德市福安市城阳镇中村村芦春路3号芦春小区22幢B梯707室',
    officeHours: '周一至周五 09:00 - 18:00',
    contactWechat: '',
    filingSubject: '宁德市天晓传媒有限公司',
    contactItems: [
      { label: '公司名称', value: '宁德市天晓传媒有限公司' },
      { label: '所在地区', value: '福建省宁德市福安市' },
      { label: '所属行业', value: '互联网技术开发 · 数字文化服务' },
      { label: '联系邮箱', value: '999330119@qq.com' },
    ],
    productSectionTitle: '主营服务',
    productItems: [
      {
        name: '软件开发与技术服务',
        desc: '提供软件开发、网络技术服务与系统集成，帮助客户完成业务系统与应用的研发落地。',
        tags: ['软件开发', '网络技术', '系统集成'],
      },
      {
        name: '数字文化与视听内容',
        desc: '提供数字文化创意内容应用、信息网络传播视听节目与网络文化经营等内容服务。',
        tags: ['数字文化', '视听内容', '网络文化'],
      },
      {
        name: '信息技术与数据服务',
        desc: '提供信息技术咨询、数据处理和存储支持以及互联网信息服务，支撑数字化运营。',
        tags: ['信息技术', '数据服务', '信息服务'],
      },
    ],
    caseSectionTitle: '案例展示',
    caseItems: [
      {
        title: '企业软件系统开发项目',
        summary: '为客户提供业务系统的需求梳理、软件开发与系统集成落地服务。',
        result: '帮助客户提升业务流程的数字化与运行效率。',
      },
      {
        title: '数字文化内容制作项目',
        summary: '围绕数字文化主题完成视听内容的策划、制作与网络传播。',
        result: '提升内容在网络平台上的传播覆盖与用户互动表现。',
      },
      {
        title: '数据与信息技术服务项目',
        summary: '结合信息技术咨询与数据处理存储支持，为企业搭建数据化运营能力。',
        result: '增强企业数据管理与信息化建设的规范性与效率。',
      },
    ],
  },
}
